import { Component } from 'preact'
import cx from 'classnames'
import { connect } from 'unistore/preact'

import { IconConfirmSolid } from '../../icons/confirm-solid'
import s from './membership-summary.sass'
import { IconChevronDown } from '../../icons/chevron-down'
import { IconChevronUp } from '../../icons/chevron-up'
import { isDesktop } from '../../../helpers/devices'
import GymCardV2 from '../../gym-card-v2'
import { getPriceAndLabel, getSuggested } from '../selectors'
import { getToken } from '../../../login'
import { getMe } from './actions'
import Loader from '../../loader'

class MembershipSummary extends Component {
  state = { isOpen: isDesktop(), maxHeight: null, isLoadingProfile: false }

  contentRef = null

  componentDidMount () {
    this.setMaxHeight()

    if (getToken()) {
      this.setState({ isLoadingProfile: true })
      this.props.getMe()
        .then(() => {
          this.setState({
            isLoadingProfile: false
          })
        })
        .catch((error) => {
          this.setState({
            isLoadingProfile: error,
            profileError: error.message
          })
        })
    }
  }

  handleOnTrigger (nextState) {
    const maxHeight = this.calculateMaxHeight(nextState)

    this.setState({
      isOpen: nextState,
      maxHeight
    })
  }

  calculateMaxHeight (nextState) {
    if (!this.contentRef) return

    if (nextState) {
      const boundingrect = this.contentRef.getBoundingClientRect()
      const windowHeight = window.innerHeight

      return `calc(${windowHeight - boundingrect.top}px - 2rem - 1rem)` // maxheight - padding - margin
    }

    return 0
  }

  setMaxHeight () {
    const maxHeight = this.calculateMaxHeight(isDesktop())

    this.setState({ maxHeight })
  }

  render ({
    price,
    signUpInput,
    signUpAddOns,
    signUpPersonalInfo,
    signUpSuggestion,
    suggestion,
    inputs,
    addOnsCopy,
    paymentInfo
  }, {
    isOpen,
    maxHeight,
    isLoadingProfile,
    profileError
  }) {
    const combinedClassNames = cx(
      s.membershipSummary,
      isOpen && s.isOpen
    )

    const Icon = isOpen
      ? IconChevronUp
      : IconChevronDown

    const srcData = {
      ...inputs,
      upgrade: {
        ...inputs.upgrade,
        inputs: signUpSuggestion && signUpSuggestion.upgradeableTo.upgradeableMemberships
      }
    }

    return (
      <div className={combinedClassNames}>
        <div className={s.overlay} />

        <div className={s.collapsible}>
          <div className={s.trigger} onClick={() => this.handleOnTrigger(!isOpen)}>
            <div>
              <div className={s.triggerLabel}>Ditt medlemskap</div>
              <div className={s.triggerTypeAndPrice}>{suggestion && suggestion.title} {price.amount}</div>
            </div>
            <Icon />
            <GymCardV2 className={s.triggerCard} color={suggestion && suggestion.cardColor} />
          </div>
          <div ref={(element) => { this.contentRef = element }} className={s.content} style={{ maxHeight }}>
            <div>
              <GymCardV2 className={s.card} color={suggestion && suggestion.cardColor} />
              <div className={s.bindingTime}>{(signUpAddOns.includes('FLEX') || signUpSuggestion.includedAddOns.includes('FLEX')) ? 'Löpande med 2 månaders uppsägningstid.' : `${paymentInfo && paymentInfo.periodMonths ? paymentInfo.periodMonths : '-'} månaders bindningstid.`}</div>
            </div>
            <ul className={s.list}>

              {/* All the user inputs */}
              {Object.keys(signUpInput).map((inputKey, key) => {
                const v = signUpInput[inputKey] && srcData[inputKey].inputs.find(e => e.value === signUpInput[inputKey] || (e.id && e.id === signUpInput[inputKey]))
                return v
                  ? <li className={s.item} key={`input-${key}`}><IconConfirmSolid /> {v.name || v.title || 'Attribut saknas'} {v.description && typeof v.description === 'string' && `(${v.description})`}</li>
                  : null
              })}

              {/* All the included AddOns */}
              {suggestion && suggestion.includedAddOns.map((addOnKey, key) => {
                const v = addOnsCopy[addOnKey]
                return v
                  ? <li className={s.item} key={`included-${key}`}><IconConfirmSolid /> {v.name || v.title || 'Attribut saknas'} {v.description && typeof v.description === 'string' && `(${v.description})`}</li>
                  : null
              })}

              {/* All the user selected AddOns */}
              {signUpAddOns.map((addOnKey, key) => {
                const v = addOnsCopy[addOnKey]

                return v
                  ? <li className={s.item} key={`selected-${key}`}><IconConfirmSolid /> {v.name || v.title || 'Attribut saknas'} {v.description && typeof v.description === 'string' && `(${v.description})`}</li>
                  : null
              })}
            </ul>
            <div className={s.priceSummary}>
              {price.label}
              <div className={s.price}>{price.amount}</div>
            </div>
            <div className={s.divider}>
              <hr />
            </div>
            {isLoadingProfile
              ? <Loader style={{ margin: '1rem 0' }} />
              : (
                <div className={s.person}>
                  <div className={s.name}>{signUpPersonalInfo.firstName} {signUpPersonalInfo.lastName}</div>
                  <div>{signUpPersonalInfo.street} <br /> {signUpPersonalInfo.postalCode} {signUpPersonalInfo.city}</div>
                  <div>{signUpPersonalInfo.email} <br /> {signUpPersonalInfo.phone}</div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

export const selectors = (state) => {
  const { signUpInput, signUpAddOns, signUpPersonalInfo, signUpSuggestion, paymentInfo } = state
  return {
    price: getPriceAndLabel(state),
    signUpInput,
    signUpAddOns,
    signUpPersonalInfo,
    suggestion: getSuggested(state),
    signUpSuggestion,
    paymentInfo
  }
}

export default connect(selectors, { getMe })(MembershipSummary)



// WEBPACK FOOTER //
// ./components/signup-flow/step-payment/membership-summary.js